interface Props {
	className?: string;
}

export const Cruz: React.FC<Props> = ({ className }) => {
	return (
		<svg
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M12.4165 6.1875V6.25H12.479H15.854C16.1358 6.25 16.406 6.36194 16.6053 6.5612C16.8046 6.76046 16.9165 7.03071 16.9165 7.3125V10.6875C16.9165 10.9693 16.8046 11.2395 16.6053 11.4388C16.406 11.6381 16.1358 11.75 15.854 11.75H12.479H12.4165V11.8125V15.1875C12.4165 15.4693 12.3046 15.7395 12.1053 15.9388C11.906 16.1381 11.6358 16.25 11.354 16.25H7.979C7.69721 16.25 7.42696 16.1381 7.2277 15.9388C7.02845 15.7395 6.9165 15.4693 6.9165 15.1875V11.8125V11.75H6.854H3.479C3.19721 11.75 2.92696 11.6381 2.7277 11.4388C2.52845 11.2395 2.4165 10.9693 2.4165 10.6875V7.3125C2.4165 7.03071 2.52845 6.76046 2.7277 6.5612C2.92696 6.36194 3.19721 6.25 3.479 6.25H6.854H6.9165V6.1875V2.8125C6.9165 2.53071 7.02845 2.26046 7.2277 2.0612C7.42696 1.86194 7.69721 1.75 7.979 1.75H11.354C11.6358 1.75 11.906 1.86194 12.1053 2.0612C12.3046 2.26046 12.4165 2.53071 12.4165 2.8125V6.1875ZM15.854 10.75H15.9165V10.6875V7.3125V7.25H15.854H11.9165C11.7839 7.25 11.6567 7.19732 11.563 7.10355C11.4692 7.00979 11.4165 6.88261 11.4165 6.75V2.8125V2.75H11.354H7.979H7.9165V2.8125V6.75C7.9165 6.88261 7.86383 7.00979 7.77006 7.10355C7.67629 7.19732 7.54911 7.25 7.4165 7.25H3.479H3.4165V7.3125V10.6875V10.75H3.479H7.4165C7.54911 10.75 7.67629 10.8027 7.77006 10.8964C7.86383 10.9902 7.9165 11.1174 7.9165 11.25V15.1875V15.25H7.979H11.354H11.4165V15.1875V11.25C11.4165 11.1174 11.4692 10.9902 11.563 10.8964C11.6567 10.8027 11.7839 10.75 11.9165 10.75H15.854Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="0.125"
			/>
		</svg>
	);
};
